import produce from 'immer';
import { reject } from 'lodash/fp';
import * as actions from './actions';

const initialState = {
  activeStatus: { loading: false, data: null, error: null },
  newsletter: { loading: false, data: null, error: null },
  survey: { loading: false, data: null, error: null },
  stats: { loading: false, data: null, error: null },
  individuals: { loading: false, data: null, error: null },
  responseDeleted: { loading: false, data: null, error: null },
  questionUpdate: { error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_NEWSLETTER_REQUEST:
      draft.newsletter.loading = true;
      break;
    case actions.FETCH_NEWSLETTER_SUCCESS:
      draft.newsletter.loading = false;
      draft.newsletter.data = action.payload.newsletter;
      break;
    case actions.FETCH_NEWSLETTER_FAILURE:
      draft.newsletter.loading = false;
      draft.newsletter.error = action.payload.error;
      break;
    case actions.FETCH_SURVEY_REQUEST:
      draft.survey.loading = true;
      break;
    case actions.FETCH_SURVEY_SUCCESS:
      draft.survey.loading = false;
      draft.survey.data = action.payload.survey;
      break;
    case actions.FETCH_SURVEY_FAILURE:
      draft.survey.loading = false;
      draft.survey.error = action.payload.error;
      break;
    case actions.FETCH_STATS_REQUEST:
      draft.stats.loading = true;
      break;
    case actions.FETCH_STATS_SUCCESS:
      draft.stats.loading = false;
      draft.stats.data = action.payload.stats;
      break;
    case actions.FETCH_STATS_FAILURE:
      draft.stats.loading = false;
      draft.stats.error = action.payload.error;
      break;
    case actions.FETCH_INDIVIDUALS_REQUEST:
      draft.individuals.loading = true;
      break;
    case actions.FETCH_INDIVIDUALS_SUCCESS:
      draft.individuals.loading = false;
      draft.individuals.data = action.payload.individuals;
      break;
    case actions.FETCH_INDIVIDUALS_FAILURE:
      draft.individuals.loading = false;
      draft.individuals.error = action.payload.error;
      break;
    case actions.SWITCH_ACTIVE_STATUS_REQUEST:
      draft.activeStatus.loading = false;
      break;
    case actions.SWITCH_ACTIVE_STATUS_SUCCESS:
      draft.activeStatus.loading = false;
      draft.newsletter.data.status = state.newsletter.data.status === 'ongoing' ? 'closed' : 'ongoing';
      break;
    case actions.SWITCH_ACTIVE_STATUS_FAILURE:
      draft.activeStatus.loading = false;
      draft.activeStatus.error = action.payload.error;
      break;
    case actions.UPDATE_QUESTION_TITLE_REQUEST:
      draft.survey.data.questions[action.payload.number - 1].content = action.payload.value;
      draft.survey.data.questions[action.payload.number - 1].prevValue = action.payload.prevValue;
      draft.survey.data.number = action.payload.number;
      break;
    case actions.UPDATE_QUESTION_TITLE_SUCCESS:
      break;
    case actions.UPDATE_QUESTION_TITLE_FAILURE:
      draft.survey.data.questions[action.payload.number - 1].content = action.payload.prevValue;
      draft.questionUpdate.error = action.payload.error;
      break;
    case actions.DELETE_INDIVIDUAL_RESPONSE_REQUEST:
      draft.responseDeleted.loading = true;
      break;
    case actions.DELETE_INDIVIDUAL_RESPONSE_SUCCESS:
      draft.responseDeleted.loading = false;
      draft.newsletter.data.recordCount -= 1;
      draft.individuals.data = reject(individual => individual.id === action.payload.gcid, draft.individuals.data);
      break;
    case actions.DELETE_INDIVIDUAL_RESPONSE_FAILURE:
      draft.responseDeleted.loading = false;
      draft.responseDeleted.error = action.payload.error;
      break;
    case actions.INIT_REDUX_NEWLETTER:
      Object.assign(draft, initialState);
      break;
    case actions.INIT_STATS:
      draft.stats = { loading: false, data: null, error: null };
      break;
    case actions.INIT_INDIVIDUALS:
      draft.individuals = { loading: false, data: null, error: null };
      break;
    case actions.INIT_QUESTION_UPDATE:
      draft.questionUpdate = { error: null };
      break;
    case actions.INIT_RESPONSE_DELETED:
      draft.responseDeleted = { loading: false, data: null, error: null };
      break;
    default:
  }
});

export default reducer;
